import React from "react";
import { Flex, Text } from "@mantine/core";

export const useDataToleranceNew = (timeCollections, matchedRecords) => {
  if (timeCollections && typeof timeCollections === "object") {
    const matchedLength = matchedRecords.length;

    return [
      {
        static_text: "# of Records",
        time0s: timeCollections["0"] || 0,
        "time1-10s": (timeCollections["10"] || 0) + (timeCollections["1"] || 0),
        "10s-1m": timeCollections["60"] || 0,
        "1m-10m": timeCollections["600"] || 0,
        "10m-1h": timeCollections["3600"] || 0,
        "1h-1d": timeCollections["86400"] || 0,
        ">1d": timeCollections["86401"] || 0,
        total: <Text size="1.2em">{matchedLength}</Text>,
      },
    ];
  }

  return null;
};

export const useColumnsToleranceNew = (theme, classes) => {
  return [
    {
      accessorKey: "static_text",
      header: "",
      size: 50,
      mantineTableHeadCellProps: {
        style: {
          backgroundColor: theme.customBackgrounds.white,
        },
      },
      mantineTableBodyCellProps: {
        className: classes.toleranceStaticText,
      },
    },
    {
      accessorKey: "time0s",
      size: 50,
      header: (
        <Flex
          gap={theme.flex.gap.normal}
          align={theme.flex.align.center}
          justify={theme.flex.justify.center}
        >
          <Text size="1em">0s</Text>
        </Flex>
      ),
    },
    {
      accessorKey: "time1-10s",
      size: 50,
      header: (
        <Flex
          gap={theme.flex.gap.normal}
          align={theme.flex.align.center}
          justify={theme.flex.justify.center}
        >
          <Text size="1em">1-10s</Text>
        </Flex>
      ),
    },
    {
      accessorKey: "10s-1m",
      size: 50,
      header: (
        <Flex
          gap={theme.flex.gap.normal}
          align={theme.flex.align.center}
          justify={theme.flex.justify.center}
        >
          <Text size="1em">10s-1m</Text>
        </Flex>
      ),
    },
    {
      accessorKey: "1m-10m",
      size: 50,
      header: (
        <Flex
          gap={theme.flex.gap.normal}
          align={theme.flex.align.center}
          justify={theme.flex.justify.center}
        >
          <Text size="1em">1m-10m</Text>
        </Flex>
      ),
    },
    {
      accessorKey: "10m-1h",
      size: 50,
      header: (
        <Flex
          gap={theme.flex.gap.normal}
          align={theme.flex.align.center}
          justify={theme.flex.justify.center}
        >
          <Text size="1em">10m-1h</Text>
        </Flex>
      ),
    },
    {
      accessorKey: "1h-1d",
      size: 50,
      header: (
        <Flex
          gap={theme.flex.gap.normal}
          align={theme.flex.align.center}
          justify={theme.flex.justify.center}
        >
          <Text size="1em">1h-1d</Text>
        </Flex>
      ),
    },
    {
      accessorKey: ">1d",
      size: 50,
      header: (
        <Flex
          gap={theme.flex.gap.normal}
          align={theme.flex.align.center}
          justify={theme.flex.justify.center}
        >
          <Text size="1em">&gt; 1d</Text>
        </Flex>
      ),
    },

    {
      accessorKey: "total",
      size: 50,
      mantineTableBodyCellProps: {
        className: classes.toleranceTotalBodyCell,
      },
      mantineTableHeadCellProps: {
        className: classes.toleranceTotalHeadCell,
      },
      header: (
        <Flex
          gap={theme.flex.gap.normal}
          align={theme.flex.align.center}
          justify={theme.flex.justify.center}
        >
          <Text size="1em">Total</Text>
        </Flex>
      ),
    },
  ];
};

export const useTableToleranceNew = (
  columnsTolerance,
  dataTolerance,
  theme,
  classes,
) => {
  return {
    columns: columnsTolerance,
    data: dataTolerance,
    enableSorting: false,
    enableFullScreenToggle: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,

    enableColumnActions: false,

    withColumnBorders: true,

    mantineTableProps: {
      style: {
        border: "none",
        borderCollapse: "collapse",
      },
      className: "html-table html-table-custom html-table-custom-tolerance-new",
    },
    mantinePaperProps: {
      withBorder: false,
      shadow: "none",
      className: "html-table-custom-wrap html-table-custom-wrap-tolerance",
    },
    mantineTableBodyRowProps: () => ({
      style: {
        borderBottom: theme.customColors.tableBorder,
      },
    }),
    mantineTableBodyCellProps: {
      className: classes.toleranceBodyCell,
    },
    mantineTableHeadRowProps: {
      style: {
        backgroundColor: theme.customBackgrounds.table,
        textAlign: "left",
      },
    },
    mantineTableHeadCellProps: {
      align: "left",
      className: classes.toleranceHeadCell,
    },
  };
};
